import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from './find-value/findValueInArray.pipe';
import { SafePipe } from './safe/safe.pipe';
import { CampaignTypePipe } from './campaign-type/campaignType.pipe';
import { PercentagePipe } from './percentage/percentage.pipe';
import { DateFormatterPipe } from './date-formatter/date-formatter.pipe';


@NgModule({
  declarations: [FilterPipe, SafePipe, CampaignTypePipe, PercentagePipe, DateFormatterPipe],
  exports: [
    FilterPipe,
    SafePipe,
    CampaignTypePipe,
    PercentagePipe,
    DateFormatterPipe
  ],
  imports: [
    CommonModule,
  ]
})
export class SharedPipesModule { }
